import { cn } from "@/lib/utils";

interface AmendmentCardProps {
  title?: string; // nome completo da instituição
  description: string; // descrição da emenda (coleção 'amendments')
  value: number;
  category: 'health' | 'diverse' | 'education' | 'infrastructure';
  className?: string;
  colorClasses?: { textClass?: string; borderClass?: string; hoverClass?: string };
  onClick?: () => void;
}

const categoryStyles = {
  health: {
    border: 'border-l-success',
    text: 'text-success',
    bg: 'hover:bg-success-light/20'
  },
  diverse: {
    border: 'border-l-diverse',
    text: 'text-diverse',
    bg: 'hover:bg-diverse-light/20'
  },
  education: {
    border: 'border-l-info',
    text: 'text-info',
    bg: 'hover:bg-info-light/20'
  },
  infrastructure: {
    border: 'border-l-warning',
    text: 'text-warning',
    bg: 'hover:bg-warning-light/20'
  }
};

export function AmendmentCard({ title, description, value, category, className, colorClasses, onClick }: AmendmentCardProps) {
  const formatCurrency = (val: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(val);
  };

  const styles = categoryStyles[category];

  return (
    <div 
      className={cn(
        "bg-card rounded-lg shadow-sm border-l-4 p-6 transition-all duration-300",
        "hover:shadow-elevated hover:-translate-y-1",
        colorClasses?.borderClass ?? styles.border,
        colorClasses?.hoverClass ?? styles.bg,
        onClick ? 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ring-offset-background' : '',
        className
      )}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      data-value={value}
    >
      {title ? (
        <p className="font-semibold text-card-foreground mb-1 leading-tight break-words whitespace-normal">
          {title}
        </p>
      ) : null}
      <p className="text-sm text-muted-foreground mb-3 leading-relaxed break-words whitespace-pre-line max-h-32 overflow-y-auto" aria-label="Descrição da emenda">
        {description}
      </p>
      <p className={cn("text-2xl font-bold", colorClasses?.textClass ?? styles.text)}>
        {formatCurrency(value)}
      </p>
    </div>
  );
}
